import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useDayPartSectionStyles } from '../styles/DayPartSection.styles';
import { useDayPartData, BaseWeekHours } from '../hooks/useDayPartData';
import { getTruncatedTextProps, getBorderRadiusStyles } from '../common/utils';

interface DayPartSectionProps {
  weekDays: Date[];
  baseWeekHours: BaseWeekHours;
  is12HFormat: boolean;
}

function DayPartSection({
  weekDays,
  baseWeekHours,
  is12HFormat,
}: DayPartSectionProps) {
  const classes = useDayPartSectionStyles();
  const { t } = useTranslation();

  const { dayparts, getDaypartData } = useDayPartData({
    weekDays,
    baseWeekHours,
    is12HFormat,
  });

  return (
    <div className={classes.sectionGroup}>
      {dayparts.map((daypart, daypartIndex) => (
        <div
          key={daypart.key}
          className={
            daypartIndex === dayparts.length - 1 ? '' : classes.timeSlotRow
          }
        >
          <div className={classes.weekGrid}>
            {weekDays.map((day, dayIndex) => {
              const daypartData = getDaypartData(dayIndex, daypart.label);

              // Calculate border radius based on position
              const borderRadius = getBorderRadiusStyles(
                daypartIndex,
                dayparts.length,
              );

              return (
                <div
                  key={`${daypart.key}-${dayIndex}`}
                  className={classes.dayCardGray}
                  style={{
                    ...borderRadius,
                    minWidth: 0,
                    width: '100%',
                  }}
                >
                  <div style={{ minHeight: '50px', width: '100%' }}>
                    {(() => {
                      const { displayText, tooltipTitle } =
                        getTruncatedTextProps(daypart.label);
                      return (
                        <Typography
                          className={classes.serviceName}
                          style={{
                            width: '100%',
                          }}
                          title={tooltipTitle}
                        >
                          {displayText}
                        </Typography>
                      );
                    })()}
                    <Typography className={classes.serviceTime}>
                      {daypartData.na ? t('app.common.na') : daypartData.time}
                    </Typography>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

export default DayPartSection;
